import type { SessionUser } from "./sessionUser";

const KEY = "apitomcp:session:v1";

export function readCachedSessionUser(): SessionUser | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const user = JSON.parse(raw) as SessionUser;
    return user?.email ? user : null;
  } catch {
    return null;
  }
}

export function writeCachedSessionUser(user: SessionUser | null): void {
  if (typeof window === "undefined") return;
  try {
    if (!user?.email) sessionStorage.removeItem(KEY);
    else sessionStorage.setItem(KEY, JSON.stringify(user));
  } catch {
    /* quota */
  }
}
